class TemperatureRating extends window.BAO.CustomElement {
  constructor () {
    super()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.hasRun = false

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()

    this.setupListeners()

    this.initialiseTabs()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  initialiseTabs () {
    this.els.trigger.elements.forEach(triggerEl => {
      triggerEl.addEventListener('click', this.handleTrigger.bind(this))
    })
  }

  handleTrigger = event => {
    this.els.trigger.elements.forEach(triggerEl => {
      triggerEl.setAttribute('aria-pressed', triggerEl === event.target)
    })
    
    this.els.trigger.elements.forEach(triggerEl => {
      if (triggerEl.getAttribute('aria-pressed') == 'true'){
        let temperatureMetric = triggerEl.getAttribute('data-temperature-rating-metric')
        this.els.dial.element.classList.remove(`prd-TemperatureDial-animate`);
        this.animateValue(temperatureMetric);
        this.animateCounter(temperatureMetric)
      }
    })

  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.animateOnScroll()
  }

  animateOnScroll () {

    const itemTriggerPoint =
      this.getOffsetTop(this.els.temperature.element) -
      (window.innerHeight / 3) * 2

    if (this.lastKnownY > itemTriggerPoint && this.hasRun === false) {
      this.hasRun = true

      this.els.trigger.elements.forEach(triggerEl => {
        if (triggerEl.getAttribute('aria-pressed') == 'true'){
          let temperatureMetric = triggerEl.getAttribute('data-temperature-rating-metric')
          this.animateValue(temperatureMetric);
          this.animateCounter(temperatureMetric)
        }
      })
    }
  }

  animateValue (e) {

    let base_amount;

    if (e === "celcius"){
      this.dataset.sign === 'positive'
        ? base_amount = parseInt(this.els.dial.element.dataset.temperatureValueEl)
        : base_amount = 0 - parseInt(this.els.dial.element.dataset.temperatureValueEl)
    } else {
      this.dataset.sign === 'positive'
        ? base_amount = (parseInt(this.els.dial.element.dataset.temperatureValueEl) * 1.8) + 32
        : base_amount = ((parseInt(this.els.dial.element.dataset.temperatureValueEl) * -1) * 1.8) + 32
    }

    const circle_length = 785

    let percent_amount = base_amount/100.0
    let arrow_rotate = 360 * percent_amount
    let gauge_precent = circle_length * percent_amount
    let gauge_amount = circle_length - gauge_precent

    this.els.dial.element.style.setProperty('--GaugeAmount', gauge_amount);
    this.els.dial.element.style.setProperty('--ArrowRotate', arrow_rotate + "deg");



    this.els.dial.element.classList.remove(`prd-TemperatureDial-animate`);

    this.els.dial.element.offsetWidth;

    this.els.dial.element.classList.add(`prd-TemperatureDial-animate`);
  }

  animateCounter (e) {
    if (this.dataset.temperature === '0' && e === 'celcius') {
      this.els.temperature.element.textContent = 0
      this.querySelector('#prd-TemperatureDial_Celcius').innerHTML = '&deg;C'
      return
    }

    const finalTemperature = parseInt(this.dataset.temperature)

    const temperatureAbbr = this.querySelector('#prd-TemperatureDial_Celcius')

    const fahrenheit = 
      this.dataset.sign === 'positive'
        ? (finalTemperature * 1.8) + 32
        : ((finalTemperature * -1) * 1.8) + 32

    const celcius =
      this.dataset.sign === 'positive'
        ? finalTemperature
        : finalTemperature * -1

    const start = 0
    const end =
      e === 'fahrenheit'
        ? fahrenheit
        : celcius
      
    const range = end - 0
    let current = start
    const increment = end > start ? 1 : -1
    const stepTime = Math.abs(Math.floor(2000 / range))

    const timer = setInterval(() => {
      current += increment
      this.els.temperature.element.textContent = current

      if (current === end) {
        clearInterval(timer)
      }

      e === 'fahrenheit'
      ? temperatureAbbr.innerHTML = '&deg;F'
      : temperatureAbbr.innerHTML = '&deg;C'

    }, stepTime)

    
  }

  getOffsetTop (el, parent = document.body, offsetTop = 0) {
    if (!el.offsetParent) {
      return el.offsetTop
    }
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop
    }

    return el.offsetParent === parent
      ? offsetTop
      : this.getOffsetTop(el.offsetParent, parent, offsetTop)
  }
}

customElements.define('temperature-rating', TemperatureRating)
